import React from 'react';
import { FilterRendererProps } from '../../DataTable.types';
import { Button } from '../../../';
import styles from './FilterRenderer.module.scss';
import MultiSelectSearchDropdown from '../../../../ManageDealDrawer/Components/MultiSelectSearchDropdown/MultiSelectSearchDropdown';
import closeIcon from '../../../SideDrawer/close.svg';
export const MultiSelectFilterRenderer: React.FC<FilterRendererProps> = ({ column, value, onChange, options }) => {
    // Ensure value is always an array to prevent controlled/uncontrolled input warnings
    const safeValue = Array.isArray(value) ? value : [];
    const isApplied = safeValue.length > 0;

    const handleClear = (e: React.MouseEvent) => {
        e.preventDefault();
        onChange([]);
    };

    const handleToggleSelection = (selectedOptions: string[]) => {
        // Ensure we always pass an array
        onChange(Array.isArray(selectedOptions) ? selectedOptions : []);
    };

    return (
        <div className={styles.FilterRenderer}>
            <div className={isApplied ? styles.FilterApplied : styles.FilterContainer}>
                <div className={styles.FilterRow}>
                    <div className={styles.FilterLabel}>{column?.filterConfig?.label || column.headerLabel}</div>
                    <div className={styles.FilterDropdown}>
                        <MultiSelectSearchDropdown
                            options={options || []}
                            selectedItems={safeValue}
                            placeholder={'All'}
                            toggleSelection={handleToggleSelection}
                        />
                    </div>
                    {isApplied && (
                        <Button
                            text=""
                            icon={closeIcon}
                            type="reset"
                            onClick={handleClear}
                            variant="white"
                            style={{
                                marginTop: 0,
                                border: '1px solid #E7E7E7',
                                color: '#4D4D4D',
                                fontSize: '0.875rem',
                                padding: '0.5rem 0.75rem',
                                minWidth: 'auto',
                                flexShrink: 0,
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
